import { OBJECTIVES } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Vision = () => (
  <section id="vision" className="py-24 sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow>Vision</Eyebrow>
        <blockquote data-testid="vision-statement-card" className="mt-8 font-display text-3xl sm:text-5xl lg:text-[4.2rem] leading-[1.08] tracking-tight text-[#0B2B26] max-w-6xl">
          “To bridge <span className="italic text-[#B4502C]">traditional Indian health wisdom</span> with modern urban healthcare needs — making sustainable wellness, preventive care and personalised health management accessible to households.”
        </blockquote>
      </Reveal>

      <div className="mt-20 sm:mt-28 grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <div data-testid="mission-statement-card" className="rounded-[28px] bg-[#E6F0EE] p-8 sm:p-10 lg:sticky lg:top-32">
            <Eyebrow>Mission</Eyebrow>
            <p className="mt-6 text-lg sm:text-xl text-[#0B2B26] leading-relaxed">
              To provide an integrated healthcare experience combining clinical consultation, preventive health assessment, lifestyle counselling and structured wellness programmes — with practical interventions that fit into the everyday routines of individuals and families.
            </p>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <Reveal><p className="font-mono text-xs uppercase tracking-[0.24em] text-[#4A6660]">Business objectives</p></Reveal>
          <ul data-testid="strategic-objectives-grid" className="mt-6 border-t border-[#0E4D44]/15">
            {OBJECTIVES.map((o, i) => (
              <Reveal key={o.name} as="li" delay={i * 0.04} className="objective-row group border-b border-[#0E4D44]/15 py-6 grid grid-cols-[3rem_1fr] sm:grid-cols-[3rem_1fr_1.3fr] gap-x-4 gap-y-2 items-baseline">
                <span className="font-mono text-xs text-[#B4502C]">0{i + 1}</span>
                <h3 className="font-display text-2xl sm:text-3xl tracking-tight text-[#0B2B26] transition-transform duration-500 group-hover:translate-x-2">{o.name}</h3>
                <p className="col-start-2 sm:col-start-3 text-sm sm:text-base text-[#33504A]">{o.desc}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
